<template lang="pug">
  .category-info(v-loading="loading")
    title-bar {{ $t(categoryName) }}
    .category-info__item(
      v-if="data && processedData.length === data.length && !processedData.some(d => !d)"
      v-for="item,index in processedData"
      :key="index"
    )
      .category-info__item__content
        .category-info__item__content__brief
          div
            p {{ $t('项目名称') }}
            p(:title="item.project_name") {{ item.project_name }}
          div
            p {{ $t('客户名称') }}
            p(:title="item.client_name") {{ item.client_name }}
          div
            p {{ $t('品牌') }}
            p(:title="item.brand_name") {{ item.brand_name }}
        .category-info__item__content__scope
          div
            p {{ $t('行业') }}
            p(:title="item.industry_name") {{ $t(item.industry_name) }}
          div
            p {{ $t('合作开始时间') }}
            p(:title="item.working_together_since") {{ item.working_together_since }}
          div
            p Scope
            p(:title="item.scope_name") {{ item.scope_name }}
        .category-info__item__content__des
          div
            p {{ $t('案例介绍') }}
            p(:title="item.introduction") {{ item.introduction }}
      .category-info__item__pic
        .category-info__item__pic__title {{ item.file_name }}
        .category-info__item__pic__img
          a(
            :href="item.download_url"
            target="_blank"
          )
            img(
              :src="item.show_case_thumbnail_download_path"
              :class="{ widthFixed: item.width/item.height >= 2, heightFixed: item.width/item.height < 2 }",
            )
    no-data(v-if="data && data.length === 0")
    .category-info__footer
      el-button(
        type="primary"
        @click="$router.go(-1)"
      ) {{ $t('返回基本信息') }}
</template>

<script>
import TitleBar from '@/components/TitleBar'
import axios from 'axios'
import NoData from '@/components/NoData'

export default {
  components: {
    TitleBar,
    NoData
  },
  data () {
    return {
      data: null,
      processedData: [],
      loading: false
    }
  },
  computed: {
    vendorId () {
      return this.$store.state.vendor.id
    },
    categoryId () {
      return this.$store.state.vendor.categoryId
    },
    categoryName () {
      return this.$store.state.vendor.categoryName
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    processImg () {
      const self = this
      this.data.forEach((d, i) => {
        if (d.show_case_thumbnail_download_path) {
          let img = new Image()
          img.src = d.show_case_thumbnail_download_path
          img.addEventListener('load', function () {
            d.height = this.naturalHeight
            d.width = this.naturalWidth
            self.processedData.splice(i, 0, d)
          })
        } else {
          self.processedData.splice(i, 0, d)
        }
      })
    },
    fetchData () {
      this.loading = true
      axios
        .get('/vendor/vendor/getCategoryDetail', {
          params: {
            vendor_id: this.vendorId,
            category_id: this.categoryId
          }
        })
        .then(res => {
          this.data = res
          this.processImg()
          this.loading = false
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
.category-info__item
  display flex
  padding 30px 0
  margin 0 30px
  border-bottom 0.5px solid #b7b7b7

.category-info__item__content
  width 700px
  min-width 700px

.category-info__item__content__brief
  margin-bottom 20px
  display: flex
  div
    width 200px
  > div > p:nth-child(2)
    white-space nowrap

.category-info__item__content__scope
  margin-bottom 20px
  display: flex
  > div > p:nth-child(2)
    white-space nowrap
  > div:nth-child(1)
    width 200px
  > div:nth-child(2)
    width 200px

.category-info__item__content__des
  div
    width 600px
  > div > p:nth-child(2)
    height 32px
    display: -webkit-box
    -webkit-line-clamp: 2
    -webkit-box-orient: vertical

.category-info__item__content__des
.category-info__item__content__scope
.category-info__item__content__brief
  > div > p
    margin-top 0
  > div > p:nth-child(1)
    color $main
  > div > p:nth-child(2)
    text-overflow: ellipsis
    width 310px
    overflow: hidden

.category-info__item__pic
  margin-left 20px

.category-info__item__pic__title
  margin-bottom 10px

.category-info__item__pic__img
  width 250px
  height 125px
  padding 5px
  border 1px solid $main
  border-radius 5px
  display: flex
  justify-content: center
  align-items: center
  .widthFixed
    width 250px
  .heightFixed
    height 125px

.category-info__footer
  display: flex
  justify-content: center
  padding: 20px
</style>
